<template>
  <div class="about-us container" v-html="aboutUsInfo"></div>
</template>

<script>
export default {
  name: "AboutUs",
  components: {},
  data() {
    return {
      aboutUsInfo: ""
    };
  },
  props: {},
  computed: {
    
  },
  async mounted() {
    this.aboutUsInfo = sessionStorage.getItem('aboutUsInfo') ?? "";
  },
  methods: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.about-us {
    margin-top: 62px;
    margin-bottom: 62px;
    line-height: 1.5;
}
</style>
